import { SETTINGS_GET_VIEW_MODE } from './types';

export const getters = {
  [SETTINGS_GET_VIEW_MODE]: state => {
    return state.viewMode;
  }
};
